import React, { memo, useState } from 'react';
import { Button, Dialog, Line, Spacing, Typography } from 'components/src';
import { View } from 'react-native';
import { Select } from 'components/src';
import { useTranslation } from 'react-i18next';
import { createUseStyles, Platform, useLang, useTheme } from 'core/src';
import FontAwesome6_Regular from 'react-native-vector-icons/FontAwesome6';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import Fontisto from 'react-native-vector-icons/Fontisto';
import { UpdatePassword } from '../updatePassword';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const FontAwesome6_RegularX =
  FontAwesome6_Regular as unknown as React.ComponentType<any>;
const FontistoX = Fontisto as unknown as React.ComponentType<any>;

interface ProfileSettingProps {
  statusDefualt: string;
}

const ProfileSetting = memo(({ statusDefualt }: ProfileSettingProps) => {
  const { theme, changeTheme } = useTheme();
  const { i18n } = useTranslation();
  const { styles, colors } = useStyles();
  const { lang, changeLang } = useLang();
  const [modalVisible, setModalVisible] = useState(false);

  const statusOptions = [i18n.t('online'), i18n.t('busy'), i18n.t('away')];

  const languegeOptions = [i18n.t('persian'), i18n.t('english')];

  const themeOptions = [
    i18n.t('dark'),
    i18n.t('light'),
    i18n.t('rose'),
    i18n.t('white'),
  ];

  const handleModalClose = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Typography text={i18n.t('setting')} classes={styles.headerText} />
      <View style={styles.box}>
        <Select
          title={i18n.t('status')}
          options={statusOptions}
          defualt={i18n.t(statusDefualt) ?? i18n.t('online')}
          children={
            <View style={styles.icon}>
              <FontAwesome6_RegularX
                name="signal"
                size={20}
                color={colors.color01}
              />
            </View>
          }
        />

        <Line />

        <Select
          title={i18n.t('languege')}
          options={languegeOptions}
          defualt={lang === 'en' ? i18n.t('english') : i18n.t('persian')}
          changeLang={changeLang}
          children={
            <View style={styles.icon}>
              <FontAwesome6_RegularX
                name="globe"
                size={25}
                color={colors.color01}
              />
            </View>
          }
        />

        <Line />

        <Select
          children={
            <View style={styles.icon}>
              <MaterialIconsX
                name="color-lens"
                size={25}
                color={colors.color01}
              />
            </View>
          }
          title={i18n.t('theme')}
          options={themeOptions}
          defualt={
            theme === 'light'
              ? i18n.t('light')
              : theme === 'dark'
                ? i18n.t('dark')
                : theme === 'rose'
                  ? i18n.t('rose')
                  : i18n.t('white')
          }
          changeTheme={changeTheme}
        />
        <Line />

        <Button
          onClick={() => {
            setModalVisible(true);
          }}
          classes={{ paddingVertical: 8 }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <View style={styles.icon}>
              <FontistoX name="key" size={21} color={colors.color01} />
            </View>
            <Spacing horizontal={1} />
            <Typography
              text={i18n.t('updatePassword')}
              weight={'bold'}
              margin={3}
              color={colors.primaryColor}
            />
          </View>
        </Button>

        <Dialog
          handleModalClose={handleModalClose}
          classesIn={styles.modalContent}
          classesOut={styles.modalContainer}
          modalVisible={modalVisible}
          animationType={'fade'}
        >
          <UpdatePassword />
        </Dialog>
      </View>
    </>
  );
});

const useStyles = createUseStyles(({ theme, colors }) => ({
  header: {
    paddingLeft: 15,
    color: colors.color01,
    fontWeight: 'bold',
  },
  box: {
    padding: 10,
    margin: 10,
    borderRadius: 20,
    backgroundColor: colors.drawerHeaderBox,
  },
  headerText: {
    paddingLeft: 15,
    paddingRight: 15,
    color: colors.color01,
    fontWeight: 'bold',
  },
  icon: { padding: 10 },
  modalContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },

  modalContent: {
    width: Platform.isDesktop ? '50%' : '90%',
    height: 'auto',
  },
}));

export { ProfileSetting };
